"use client";

import React from "react";
import { useRuntimeLocale } from "@/shared/I18nRuntimeProvider";
import { getUiLocaleDirection } from "@/lib/i18n/uiLocale";
import { RTL_PREVIEW_ENABLED, type RtlPreviewVariant } from "@/lib/i18n/rtlPreview";

const OPTIONS: { id: RtlPreviewVariant; label: string; hint: string }[] = [
  { id: "c", label: "C", hint: "Mirrored + Arabic font" },
  { id: "a", label: "A", hint: "Not mirrored" },
];

export function RtlPreviewSwitcher() {
  const { locale, rtlVariant, setRtlVariant } = useRuntimeLocale();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => setMounted(true), []);

  if (!RTL_PREVIEW_ENABLED || !mounted || getUiLocaleDirection(locale) !== "rtl") return null;

  return (
    <div
      dir="ltr"
      className="fixed bottom-4 left-1/2 z-[2147483000] flex -translate-x-1/2 items-center gap-2 rounded-full border border-gray-200 bg-white/95 p-1 ps-3 text-xs text-gray-600 shadow-lg backdrop-blur"
      style={{ fontFamily: "system-ui, sans-serif", fontSize: 12 }}
    >
      <span>RTL</span>
      {OPTIONS.map((opt) => (
        <button
          key={opt.id}
          type="button"
          title={opt.hint}
          onClick={() => setRtlVariant(opt.id)}
          className={`rounded-full px-3 py-1.5 ${
            rtlVariant === opt.id ? "bg-indigo-600 font-medium text-white" : "hover:bg-gray-100"
          }`}
        >
          {opt.hint}
        </button>
      ))}
    </div>
  );
}
